<template>
  <div class="clientFundDataList">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList()"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.clientFund.customerNumber }}：{{ item.CustomerNumber }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.companyName }}：{{ item.CompanyName }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.mainWbNumber }}：{{ item.PWB_Number }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.sideWbNumber }}：{{ item.WB_Number }}
        </div>
        <div class="list-item">{{ $t.clientFund.invoiceNo }}：{{ item.InvoiceNo }}</div>
        <div class="list-item">
          {{ $t.clientFund.warehouseWorkNumber }}：{{ item.WarehouseWorkNumber }}
        </div>
        <div class="list-item">{{ $t.clientFund.createDate }}：{{ item.CreateTime }}</div>
        <div class="subTotal" v-if="item && item.ReceivableAmount.length > 0">
          <div class="subTotal-label">{{ $t.clientFund.dic1 }}</div>
          <div
            class="subTotal-item"
            v-for="(item, index) in item.ReceivableAmount"
            :key="index"
          >
            <div class="item1">{{ item.key }}</div>
            <div class="item2">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { List, Row, Col, Button } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button);

export default {
  name: "clientFundDataList",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      dialogVisible: false,
      CustomerId: "",
      beginTime: "",
      endTime: "",
    };
  },
  created() {
    const { CustomerId, BeginTime, EndTime } = this.$route.query;
    this.CustomerId = CustomerId;
    this.beginTime = BeginTime;
    this.endTime = EndTime;
  },
  methods: {
    getList() {
      var param = {
        CustomerId: this.CustomerId,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.financialManagement
        .getCustomerReceivedAmountDetailByCustomerIdAndDate(param)
        .then((res) => {
          this.tableData = res.data;
          if (this.tableData.length > 0) {
            for (var item of this.tableData) {
              var test1 = Object.entries(item.ReceivableAmountDic);
              var array1 = test1.map(([key, value]) => ({
                key,
                value,
              }));
              item.ReceivableAmount = array1;
            }
          }
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.clientFundDataList {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .list {
    width: 100%;
    display: inline-block;
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .warning-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: #ffba00;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .subTotal {
    margin-bottom: 10px;
    font-size: 12px;
    color: #333333;
    .subTotal-label {
      margin-bottom: 10px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .subTotal:last-child {
    margin-bottom: 0px !important;
  }
}
</style>
